import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IssueTypeComponent } from './component/issue-type.component';

import { DictionaryFieldsModule, MasterDetailModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule as MatInputModule } from '@angular/material/input';


@NgModule({
  declarations: [IssueTypeComponent],
  imports: [
    CommonModule,
    FormsModule,

    DictionaryModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    DictionaryFieldsModule,MatFormFieldModule,
    MatInputModule
  ],

})
export class IssueTypeModule { }

